module.exports = __webpack_public_path__ + "static/media/laputa.ad75fad0.jpg";